import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiMapPin } from "react-icons/fi";
import styles from "./footer.module.css";

export default function Footer() {
  const [location, setLocation] = useState<string | null>(null);

  useEffect(() => {
    if (!navigator.geolocation) {
      setLocation("unknown");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async ({ coords }) => {
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${coords.latitude}&lon=${coords.longitude}&format=json`
          );
          const data = await res.json();
          const city =
            data.address?.city || data.address?.town || data.address?.village;
          const country = data.address?.country;
          setLocation(
            city && country ? `${city}, ${country}` : country || "unknown"
          );
        } catch {
          setLocation("unknown");
        }
      },
      () => setLocation("unknown"),
      { maximumAge: 60_000 }
    );
  }, []);

  const renderLocation = () => {
    if (location === null) return "\u2026";
    if (location === "unknown") return <> Planet Earth</>;
    return location;
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.country}>
        <FiMapPin /> {renderLocation()}
      </div>

      <div className={styles.footerLinks}>
        <div className={styles.linksSection}>
          <Link to="/about">About</Link>
          <Link to="/experience">Experience</Link>
          <Link to="/projects">Projects</Link>
          <Link to="/resume">Resume</Link>
          <Link to="/email">Email</Link>
        </div>
        <div className={styles.linksSection}>
          <Link to="/maps">Maps</Link>
          <Link to="/drive">Drive</Link>
          <a href="https://github.com/jasur-2902"> GitHub </a>
          <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/jasurshukurov/">
            LinkedIn
          </a>
        </div>
      </div>
    </footer>
  );
}
